import BackToPreviousPage from './BackToPreviousPage';

export default BackToPreviousPage;
